"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var t = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "HeartIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M15 7.11201C17.5922 4.5993 21.7781 4.2735 24.4875 6.44255C28.0172 9.27214 27.4922 13.878 24.9844 16.3193L16.7625 24.2948C16.2937 24.7501 15.6703 25 15 25C14.3344 25 13.7062 24.7456 13.2375 24.2904L5.01563 16.3149C2.50313 13.8736 1.98751 9.26767 5.5125 6.44255C8.22188 4.26903 12.4078 4.5993 15 7.11201ZM6.61904 14.8107L14.8409 22.7862C14.9534 22.8933 15.0472 22.8933 15.1597 22.7862L23.3815 14.8107C25.0784 13.1638 25.4347 10.004 23.0393 8.08037C21.2253 6.62541 18.4128 6.83517 16.6409 8.55345L15.0003 10.1468L13.3597 8.55345C11.5972 6.8441 8.78467 6.62541 6.96123 8.08483C4.56123 10.0084 4.90811 13.1504 6.61904 14.8107Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
}),
    l = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "HeartIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M16.325 4.00979C14.5187 2.49145 11.7281 2.71951 10 4.47841C8.27187 2.71951 5.48125 2.48832 3.675 4.00979C1.325 5.98737 1.66875 9.21149 3.34375 10.9204L8.825 16.5033C9.1375 16.8219 9.55625 17 10 17C10.4469 17 10.8625 16.825 11.175 16.5064L16.6562 10.9235C18.3281 9.21462 18.6781 5.9905 16.325 4.00979ZM15.5875 9.86757L10.1062 15.4504C10.0312 15.5254 9.96875 15.5254 9.89375 15.4504L4.4125 9.86757C3.27188 8.70538 3.04063 6.50598 4.64063 5.15947C5.85625 4.13788 7.73125 4.29096 8.90625 5.48751L10 6.60283L11.0937 5.48751C12.275 4.28471 14.15 4.13788 15.3594 5.15635C16.9562 6.50286 16.7187 8.71476 15.5875 9.86757Z"
  }),
  svgElements: ["path"]
}),
    o = exports.c = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "HeartIconExtraSmall",
  size: "ExtraSmall",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M10.9531 3.57702C9.82421 2.7094 8.08008 2.83972 7 3.8448C5.91992 2.83972 4.17578 2.70761 3.04688 3.57702C1.57813 4.70707 1.79297 6.54942 2.83985 7.52594L6.26562 10.7161C6.46094 10.8982 6.72266 11 7 11C7.2793 11 7.53906 10.9 7.73437 10.7179L11.1602 7.52773C12.2051 6.55121 12.4238 4.70885 10.9531 3.57702ZM10.4922 6.92432L7.0664 10.1145C7.01953 10.1574 6.98047 10.1574 6.93359 10.1145L3.50781 6.92432C2.79492 6.26022 2.65039 5.00342 3.65039 4.23398C4.41016 3.65021 5.58203 3.73769 6.31641 4.42143L7 5.05876L7.68359 4.42143C8.42187 3.73412 9.59375 3.65021 10.3496 4.2322C11.3477 5.00163 11.1992 6.26557 10.4922 6.92432Z"
  }),
  svgElements: ["path"]
});

exports.a = t;
exports.b = l;
exports.c = o;